<div *ngIf="displayLogin">

    <div style="z-index: 10;">
        <!-- <div class="header-blue">
        {{'LOGIN_OD0004' | translate}}
        <div class="language-change" id="languageDropdown" (click)="changeLanguage()">
            {{ defaultLanguage === 'NL'? 'FR': 'NL' }}
          </div>
    </div> -->
    <!-- <div>
        {{'LOGIN_' | translate}}
    </div> -->

        <form [formGroup]="loginForm" (ngSubmit)="AuthenticateUser()">
            <div class="card-body border-external">
                <div style="height: 53px;">
                <span class="col-md-4">{{'LoginLabel_001' | translate}}</span>
            </div>
                <div class="form-group ">
                    <span class="col-md-4">{{'LoginUserLabel_001' | translate}}</span>
                    <span class="col-md-4">
                        <input style="background-color: #dcdcdc85;" type="text"
                            formControlName="username" placeholder="#" [(ngModel)]="username"   ></span>
                </div>

                <div class=" form-group" style="margin-top: 1.5rem;">
                    <span class="col-md-4">{{'LOGIN_OD0003' | translate}}</span>
                    <span class="d-flex col-md-4"><input style="background-color: #dcdcdc85;"
                        [type]="fieldTextType ? 'text' : 'password'"
                         formControlName="password"
                        placeholder="****************">
                    
                        <div class="input-group-append passwordtxt">
                            <span class="input-group-text">
                              <i class="fa"
                              [ngClass]="{
                                'fa-eye-slash': !fieldTextType,
                                'fa-eye': fieldTextType
                              }"
                              (click)="toggleFieldTextType()" style="cursor: pointer;font-weight: bold;width: 1px;margin-left: -8px;"></i>
                            </span>
                          </div>
                    </span>
                
                       

                </div>
                <div class="d-flex mt-4" style="justify-content: center;">
                    <!-- <img class="mr-3" src="../../../../../assets/Logos/error-message.svg"> -->
                    <div style="color:red; font-size: 18px; font-weight: bold;">{{errorMsg | translate}}</div>
                </div>
            </div>
            <div *ngIf="showMe" class="footer-class border-external">
                    <b><a  style="color: steelblue;" class="clslink"  (click)="Forgotpasswordfn()">{{ 'ForgotPasswordLink_001' | translate }}</a> </b>
                <button class="btn btn-orange border-external">
                    <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="32" height="32"
                        viewBox="0 0 172 172" style="height: 25px; fill:#000000;">
                        <g transform="">
                            <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                                stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                                style="mix-blend-mode: normal">
                                <path d="M0,172v-172h172v172z" fill="#e67e22"></path>
                                <g id="original-icon" fill="#ffffff">
                                    <path
                                        d="M53.75,16.125v53.75h10.75v-43h75.25v118.25h-75.25v-43h-10.75v53.75h96.75v-139.75zM87.84766,60.63672l-7.72656,7.72656l12.26172,12.26172h-65.50781v10.75h65.50781l-12.26172,12.26172l7.72656,7.72656l21.5,-21.5l3.69531,-3.86328l-3.69531,-3.86328z">
                                    </path>
                                </g>
                                <path d="" fill="none"></path>
                                <path d="" fill="none"></path>
                                <path d="" fill="none"></path>
                                <path d="" fill="none"></path>
                                <path d="" fill="none"></path>
                                <path d="" fill="none"></path>
                            </g>
                        </g>
                    </svg>
                    {{'LOGIN_OD0004' | translate}}
                </button>
            </div>
        </form>
    </div>
</div>
<div *ngIf="display">

    <div>
        <app-client-selection [displayClientSelection]="displayClientSelection" [clients]=clients>
        </app-client-selection>
    </div>

</div>
<div *ngIf="displayFirstLogin">

    <div>
        <app-first-login (displayLogin)="onDisplayLogin($event)"></app-first-login>
    </div>

</div>
 